import type {
  AdminPaymentRecord,
  PaymentListParams,
  PaymentListResult,
  PaymentsSummary,
} from '@/types/payment.types';

import { apiClient } from './api.service';

const cleanParams = <T extends Record<string, unknown>>(input: T): Partial<T> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(input)) {
    if (value === undefined || value === '' || value === null) continue;
    out[key] = value;
  }
  return out as Partial<T>;
};

export const paymentsApi = {
  list: (params: PaymentListParams): Promise<PaymentListResult> =>
    apiClient
      .get<PaymentListResult>('/admin/payments', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  summary: (): Promise<PaymentsSummary> =>
    apiClient.get<PaymentsSummary>('/admin/payments/summary').then((r) => r.data),

  get: (id: string): Promise<AdminPaymentRecord> =>
    apiClient.get<AdminPaymentRecord>(`/admin/payments/${id}`).then((r) => r.data),

  verify: (id: string): Promise<AdminPaymentRecord> =>
    apiClient.post<AdminPaymentRecord>(`/admin/payments/${id}/verify`, {}).then((r) => r.data),

  reject: (id: string, reason: string): Promise<AdminPaymentRecord> =>
    apiClient
      .post<AdminPaymentRecord>(`/admin/payments/${id}/reject`, { reason })
      .then((r) => r.data),

  settle: (id: string, adminRef: string): Promise<AdminPaymentRecord> =>
    apiClient
      .post<AdminPaymentRecord>(`/admin/payments/${id}/settle`, { adminRef })
      .then((r) => r.data),

  refundDeposit: (id: string, ref?: string): Promise<AdminPaymentRecord> =>
    apiClient
      .post<AdminPaymentRecord>(`/admin/payments/${id}/refund-deposit`, ref ? { ref } : {})
      .then((r) => r.data),
};
